import { render, staticRenderFns } from "./PayRangeDetailHeader.vue?vue&type=template&id=456bf45d&scoped=true"
import script from "./PayRangeDetailHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PayRangeDetailHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayRangeDetailHeader.vue?vue&type=style&index=0&id=456bf45d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456bf45d",
  null
  
)

export default component.exports